import Formatter from "@rmlibrary/formatting";

const formatter = new Formatter();

// Calculation constants.
//changed this to 26 from 365.25 to fix calculation errors.
const annualNumberOfDays = 26;
const annualNumberOfMonths = 12;
const annualNumberOfBiWeeks = 26;
//changed this to 1 from 14 to fix calculation errors.
const biWeekNumberOfDays = 1;
const contributionIncreasePeriod = 1;
const contributionSavingsPeriod = 30;
const interestRate = 0.05;
const effectiveMonthlyRate = (1 + interestRate) ** (1 / annualNumberOfMonths) - 1;
const effectiveBiWeeklyRate = (1 + interestRate) ** (biWeekNumberOfDays / annualNumberOfDays) - 1;

function calculateSavings({ annualPercentageIncrease, contributionAmount, contributionFrequency, startingAmount }) {
    const effectiveRate = contributionFrequency === "biweekly" ? effectiveBiWeeklyRate : effectiveMonthlyRate;
    const numberOfContributions = contributionFrequency === "biweekly" ? annualNumberOfBiWeeks : annualNumberOfMonths;

    let contributionAmountWithIncrease = contributionAmount;
    let contributionAmountWithoutIncrease = contributionAmount;
    let savingsWithIncrease = startingAmount;
    let savingsWithoutIncrease = startingAmount;
    let results = {
        withIncrease: {},
        withoutIncrease: {}
    };

    for (let i = 0; i < contributionSavingsPeriod; i++) {
        for (let j = 0; j < numberOfContributions; j++) {
            if (savingsWithoutIncrease) {
                savingsWithIncrease = (contributionAmountWithIncrease + savingsWithIncrease) * (effectiveRate + 1);
                savingsWithoutIncrease =
                    (contributionAmountWithoutIncrease + savingsWithoutIncrease) * (effectiveRate + 1);
            } else {
                savingsWithIncrease = contributionAmount + contributionAmountWithIncrease * effectiveRate;
                savingsWithoutIncrease = contributionAmount + contributionAmountWithIncrease * effectiveRate;
            }
        }

        if ((i + 1) % contributionIncreasePeriod === 0) {
            contributionAmountWithIncrease *= annualPercentageIncrease;
        }

        if (i === 9) {
            // 10 Years
            results.withIncrease.tenYears = savingsWithIncrease;
            results.withoutIncrease.tenYears = savingsWithoutIncrease;
        } else if (i === 19) {
            // 20 years
            results.withIncrease.twentyYears = savingsWithIncrease;
            results.withoutIncrease.twentyYears = savingsWithoutIncrease;
        } else if (i === 29) {
            // 30 years
            results.withIncrease.thirtyYears = savingsWithIncrease;
            results.withoutIncrease.thirtyYears = savingsWithoutIncrease;
        }
    }

    return results;
}

function calculateVideoResults(inputsValues) {
    let { annualPercentageIncrease, contributionAmount, startingAmount } = inputsValues;
    annualPercentageIncrease = 1 + formatter.parseNumber(annualPercentageIncrease / 100);
    contributionAmount = formatter.parseNumber(contributionAmount);
    startingAmount = formatter.parseNumber(startingAmount);

    const savingsWithBiWeeklyContributions = calculateSavings({
        annualPercentageIncrease,
        contributionAmount: contributionAmount / 2,
        contributionFrequency: "biweekly",
        startingAmount
    });
    const savingsWithMonthlyContributions = calculateSavings({
        annualPercentageIncrease,
        contributionAmount,
        contributionFrequency: "monthly",
        startingAmount
    });

    return {
        biWeeklyContributions: {
            withIncrease: savingsWithBiWeeklyContributions.withIncrease,
            withoutIncrease: savingsWithBiWeeklyContributions.withoutIncrease
        },
        monthlyContributions: {
            withIncrease: savingsWithMonthlyContributions.withIncrease,
            withoutIncrease: savingsWithMonthlyContributions.withoutIncrease
        }
    };
}

export { calculateVideoResults };
